<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <div v-if="searchItems && !loading">
      <sticky class="page-header sticky-page-header">
        <div slot="left">
          <h1>
            <strong class="">{{totalItems}} résultat<span v-if="totalItems > 1">s</span> de recherche pour "{{query.q}}"</strong>
          </h1>
        </div>
        <div slot="right-content"></div>
      </sticky>
      <div class="columns is-gapless">
        <div class="column is-two-thirds is-border-right is-border-dashed">
          <div class="columns" v-if="totalItems === 0">
            <div class="column">
              <h1 class="title">Pas de résultat</h1>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-6" v-if="searchItems.companies.length">
              <h2 class="is-2 title"><strong>Sociétés</strong></h2>
              <div>
                <div v-for="c in searchItems.companies" :key="c.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'CompanyVue', params: {id: c.pk}}"><strong>{{c.name}}</strong></router-link></span><br>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.programs.length">
              <h2 class="is-2 title"><strong>Programmes</strong></h2>
              <div>
                <div v-for="p in searchItems.programs" :key="p.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'ProgramVue', params: {id: p.pk}}"><strong>{{p.name}}</strong></router-link></span><br>
                  <span class="has-text-grey is-size-4">{{p.address.zip_code}} {{p.address.city}}</span>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.lots.length">
              <h2 class="is-2 title"><strong>Lots</strong></h2>
              <div>
                <div v-for="l in searchItems.lots" :key="l.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'LotVue', params: {id: l.pk}}"><strong>Lot {{l.ref}}<span v-if="isDistributeurMode"> - {{l.promoteur_name}}</span></strong></router-link></span><br>
                  <span class="has-text-grey is-size-4">{{l.address.zip_code}} {{l.address.city}}</span>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.programs.length">
              <h2 class="is-2 title"><strong>Sociétés</strong></h2>
              <div>
                <div v-for="p in searchItems.programs" :key="p.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'CompanyVue', params: {id: p.pk}}"><strong>{{p.name}}</strong></router-link></span><br>
                  <span class="has-text-grey is-size-4">{{p.address.zip_code}} {{p.address.city}}</span>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.promoteurs.length && isDistributeurMode">
              <h2 class="is-2 title"><strong>Promoteurs</strong></h2>
              <div>
                <div v-for="p in searchItems.promoteurs" :key="p.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'LotVue', params: {id: p.pk}}"><strong>{{p.name}}</strong></router-link></span><br>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.contacts.length">
              <h2 class="is-2 title"><strong>Contacts</strong></h2>
              <div>
                <div v-for="c in searchItems.contacts" :key="c.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'ContactVue', params: {id: c.pk}}"><strong>{{c.first_name}} {{c.last_name}}</strong></router-link></span><br>
                  <span class="has-text-grey is-size-4">{{c.email}}</span>
                </div>
              </div>
            </div>
            <div class="column is-6" v-if="searchItems.users.length">
              <h2 class="is-2 title"><strong>Utilisateur</strong></h2>
              <div>
                <div v-for="u in searchItems.users" :key="u.pk" class="is-margin-bottom">
                  <span class="is-size-3"><router-link :to="{name: 'UserVue', params: {id: u.pk}}"><strong>{{u.first_name}} {{u.last_name}}</strong></router-link></span><br>
                  <span class="has-text-grey is-size-4">{{u.email}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'SearchVue',
    data () {
      return {
        searchItems: null,
        query: this.$route.query,
        loading: true
      }
    },
    computed: {
      ...mapGetters(['isDistributeurMode']),
      totalItems () {
        return this.searchItems.programs.length + this.searchItems.lots.length + this.searchItems.users.length + this.searchItems.contacts.length + this.searchItems.companies.length
      }
    },
    watch: {
      '$route' (value) {
        this.getItems(value.query)
      }
    },
    methods: {
      getItems (query) {
        this.loading = true
        this.query = query
        this.$api.searchService.get(query).then(r => {
          this.loading = false
          this.searchItems = r.data
        }).catch(() => {
          this.loading = false
          console.log('error')
        })
      }
    },
    created () {
      this.getItems(this.query)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchVue.vue